module.exports = __webpack_public_path__ + "icons/original/large/large-d2.9a9e2546ef2de2aed7b9cafca1e574a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-d2.png
// module id = oD70
// module chunks = app